import React, {
	forwardRef, useLayoutEffect, useRef, useState,
} from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane, faTimes } from '@fortawesome/free-solid-svg-icons';
import {
	ChatTextInput, ChatWindowContent, ChatWindowFooter, ChatWindowHeader, ChatWindowWrapper, Form, Message, SendIcon, CloseButton,
} from './Chat.Atoms';

import { ColorsVariables } from '../../../../../assets/styles/colors';
import { isServer } from '../../../../../lib/helpers';

const ChatWindow = forwardRef(({
	messages,
	addMessage,
	resetMessagesUnReadCount,
	visible,
	setVisible,
}, ref) => {
	const [viewport, setViewport] = useState(null);

	const handleSubmit = async (e) => {
		e.preventDefault();
		if (!e.target.message.value) {
			return;
		}
		try {
			await addMessage(e.target.message.value);
			if (ref?.current) {
				ref.current.value = '';
			}
		} catch (error) {
			// Todo handle error when message not sent!
		}
	};
	const dummyDivRef = useRef();

	useLayoutEffect(() => {
		// This scrolls the messages div to bottom on mount!
		// And also do this on every new message!
		dummyDivRef.current.parentNode.scrollTop = dummyDivRef.current.offsetTop;
	}, [messages]);
	useLayoutEffect(() => {
		if (isServer) {
			return null;
		}
		const vp = window.visualViewport;
		setViewport(vp.height);

		function resizeHandler() {
			setViewport(vp.height);
		}
		window.visualViewport.addEventListener('resize', resizeHandler);
		return () => {
			window.visualViewport.removeEventListener('resize', resizeHandler);
		};
	}, []);

	return (
		<ChatWindowWrapper onClick={resetMessagesUnReadCount} visible={visible} viewportHeight={viewport}>
			<ChatWindowHeader>
				<p>To opponent</p>
				<CloseButton
					onClick={() => setVisible(false)}
				>
					<FontAwesomeIcon
						icon={faTimes}
						color={ColorsVariables.MainGreen}
					/>
				</CloseButton>
			</ChatWindowHeader>
			<ChatWindowContent>
				{messages.map((message, index) => (
					<Message key={`${message}${index.toString()}`} myMessage={message.myMessage}>
						{message.message}
					</Message>
				))}
				{/* dummy div used for scrolling to bottom */}
				<div ref={dummyDivRef} />
			</ChatWindowContent>
			<ChatWindowFooter>
				<Form
					onSubmit={handleSubmit}
					autoComplete="off"
				>
					<ChatTextInput
						name="message"
						placeholder="Type a message..."
						ref={ref}
					/>
					<button type="submit" onClick={() => ref.current.focus()}>
						<SendIcon icon={faPaperPlane} color={ColorsVariables.MainGreen} />
					</button>
				</Form>
			</ChatWindowFooter>
		</ChatWindowWrapper>
	);
});
ChatWindow.defaultProps = {
	messages: [],
	visible: false,
};
ChatWindow.propTypes = {
	messages: PropTypes.arrayOf(PropTypes.shape({
		message: PropTypes.string.isRequired,
		myMessage: PropTypes.bool,
	})),
	addMessage: PropTypes.func.isRequired,
	resetMessagesUnReadCount: PropTypes.func.isRequired,
	visible: PropTypes.bool,
	setVisible: PropTypes.func.isRequired,
};
export default ChatWindow;
